// extracted by mini-css-extract-plugin
export default {"description":"BlogCard_description__HOtDF","reverse":"BlogCard_reverse__fXlqt","content":"BlogCard_content__IOPvv"};